<template>
    <div>
        <v-dialog v-model="dialog_discount" v-if="dialog_discount" no-click-animation persistent lazy full-width width="290px" transition="dialog-bottom-transition">
            <v-card flat>
                  <v-card-text class="pt-4">
                      <v-form data-vv-scope="entryNote">
                        <v-text-field
                            :label="'Enter ' + $parent.selectedAddOn.name + ' Percentage'"
                            v-model="addonValue"
                            placeholder=" " 
                            type="number"
                        ></v-text-field>
                      </v-form>

                      <v-alert type="info" :value="true" font-small>This percentage will apply to all items.</v-alert>
                  </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click.native="closeDialogWeb">close</v-btn>
                  <v-btn color="blue darken-1" text @click.native="fn_applyPercentage">ok</v-btn>
                </v-card-actions>
                </v-card>	
          </v-dialog>
    </div>
</template>

<script>
export default{
    data(){	
        return{
            dialog_discount: false,
            addonValue:null
        }
    },
    props:['addOnName'],
    methods:{
        openDialogWeb: function () {	
            this.dialog_discount = true;
            this.addonValue = null;
        },
        closeDialogWeb: function () {
            this.dialog_discount = false;
        },
        fn_applyPercentage: function () {
            if(!this.addonValue){
                this.$eventHub.$emit('snackbarAlert', {msg:'Please enter a valid ' + this.$parent.selectedAddOn.name + 'percentage'});
                return;
            }

            // getting selected addons to apply on all items
			let itemsWithAddons = this.$parent.Form.items.filter(item=>{
				return item.addOnsItems && item.addOnsItems.length; 
			})

			let selectedAddonsData = null
			for(let k=0; k<itemsWithAddons.length; k++){
				for(let l=0; l<itemsWithAddons[k].addOnsItems.length; l++){
					if(itemsWithAddons[k].addOnsItems[l].addOnsId == this.$parent.selectedAddOn.addOnsId){
						selectedAddonsData = itemsWithAddons[k].addOnsItems[l];
						break;
					}
				}
				if(selectedAddonsData){
					break;
				}
			}
			// getting selected addons to apply on all items ends here
            
            for(let i=0; i<this.$parent.Form.items.length; i++){
                if(!this.$parent.Form.items[i].addOnsItems || !this.$parent.Form.items[i].addOnsItems.length){
					this.$parent.Form.items[i].addOnsItems = [selectedAddonsData];
				}
                
                for(let j=0; j<this.$parent.Form.items[i].addOnsItems.length; j++){
                    if(this.$parent.Form.items[i].addOnsItems[j].addOnsId == this.$parent.selectedAddOn.addOnsId){
                        this.$parent.Form.items[i].addOnsItems[j].percentage = this.addonValue;
                        break;
                    }
                }
                this.$parent.$refs['ref_dialogForm'].fn_computeValues(this.$parent.Form.items[i]);
            }
            this.closeDialogWeb();
        }
    }
}
</script>